<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>

<ng-template #modaloperacionesreembolso>
    <mat-dialog-content class="contenedorprincipal" [style]="{'height': AltoContenidoPrincipal()}">
        <div class="modal-header encabezadomodal">
            <h3 class="encabezadomodaltitulo encabezadomodaltitulomargen">
                Actualizar operación de reembolso
            </h3>

            <button type="button" class="confirmacionbotoncerrar" aria-label="Close" [mat-dialog-close]="false">
              <h3 class="encabezadomodaltitulo">X</h3>
            </button>
        </div>
        <div class="contenedorbody">
            <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
            <div class="contenedorsubtitulo m-2">
                <h4 class="subtituloprincipal">
                    INFORMACIÓN DEL AFILIADO
                </h4>
                <p class="textosubtitulo">
                    Esta información es parte del registro de la operación de reembolso, establezca la información correcta correspondiente al proceso.
                </p>
            </div>
            <div [formGroup]="form">
                <div class="row pr-0 pl-0 mt-4 m-0">
                    <div class="col-md-12 col-lg-12 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Dirección (*)</mat-label>
                            <input matInput formControlName="domicilio" autocomplete="off">
                            <mat-error *ngIf="form.get('domicilio').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="form.get('domicilio').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Departamento (*)</mat-label>
                            <mat-select formControlName="codigoProvincia" (ngModelChange)="Cambio_Provincia()">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasDepartamento">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('codigoProvincia').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Ciudad (*)</mat-label>
                            <mat-select formControlName="codigoCiudad" (ngModelChange)="Cambio_Ciudad()">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasCiudades">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('codigoCiudad').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-12 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Identificación (*)</mat-label>
                            <input matInput formControlName="nroDocumento" autocomplete="off">
                            <mat-error *ngIf="form.get('nroDocumento').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="form.get('nroDocumento').hasError('maxlength')">La longitud máxima es 20</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Nombres (*)</mat-label>
                            <input matInput formControlName="nombres" autocomplete="off">
                            <mat-error *ngIf="form.get('nombres').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="form.get('nombres').hasError('maxlength')">La longitud máxima es 50</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Apellidos (*)</mat-label>
                            <input matInput formControlName="apellidos" autocomplete="off">
                            <mat-error *ngIf="form.get('apellidos').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="form.get('apellidos').hasError('maxlength')">La longitud máxima es 50</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>País (*)</mat-label>
                            <mat-select formControlName="codigoPaisIndicativo" (ngModelChange)="Cambio_Indicativo()">
                                <mat-select-trigger>
                                    <div class="d-flex flex-row">
                                        <img [src]="ObtenerCodigoBandera(this.form.get('codigoPaisIndicativo').value)">
                                        <span class="p-1">
                                            +{{ObtenerIndicativo(this.form.get('codigoPaisIndicativo').value)}}
                                        </span>
                                    </div>
                                </mat-select-trigger>
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasIndicativos">
                                    <div class="d-flex flex-row">
                                        <img [src]="item.dependenciaCodigo">
                                        <span class="p-1">
                                            +{{item.id}}
                                        </span>
                                    </div>
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('codigoPaisIndicativo').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Número telefónico (*)</mat-label>
                            <input matInput formControlName="nroCelular" autocomplete="off">
                            <mat-error *ngIf="form.get('nroCelular').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="form.get('nroCelular').hasError('maxlength')">La longitud máxima es 50</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-12 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Correo electrónico (*)</mat-label>
                            <input matInput formControlName="email" autocomplete="off">
                            <mat-error *ngIf="form.get('email').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="form.get('email').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Cliente (*)</mat-label>
                            <mat-select formControlName="idAliado" (ngModelChange)="Cambio_Aliado()">
                                <mat-option [value]="item.id" *ngFor="let item of this.listasAliados">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('idAliado').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <!-- <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Canal (*)</mat-label>
                            <mat-select formControlName="idCanal">
                                <mat-option [value]="item.id" *ngFor="let item of this.listasCanales">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('idCanal').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div> -->
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Producto (*)</mat-label>
                            <mat-select formControlName="idProducto" (ngModelChange)="Cambio_Producto()">
                                <mat-option [value]="item.id" *ngFor="let item of this.listasProductos">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('idProducto').hasError('min')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Motivo (*)</mat-label>
                            <mat-select formControlName="motivo">
                                <mat-option [value]="item.codigo" *ngFor="let item of this.listasMotivos">{{item.descripcion}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="form.get('motivo').hasError('required')">Campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-6 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Expediente (*)</mat-label>
                            <input matInput formControlName="expediente" autocomplete="off">
                            <mat-error *ngIf="form.get('expediente').hasError('required')">Campo requerido</mat-error>
                            <mat-error *ngIf="form.get('expediente').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="d-flex justify-content-center contenedorbotonesfinal">
                    <div class="d-flex justify-content-start ml-2">
                        <div class="p-1">
                            <button type="button" class="botonfinal" (click)="Guardar()">
                                <div class="d-flex flex-row-reverse">
                                    <mat-icon>chevron_right</mat-icon>
                                    <span class="botoncompletotexto">Actualizar</span>
                                </div>
                            </button>
                        </div>
                        <div class="p-1">
                            <button type="button" class="botonatras" (click)="Cancelar()">
                                <span class="botoncompletotexto">Atras</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
</ng-template>